// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"54a88f36","309":"65751213","352":"592a02ce","700":"2e71f96b","799":"d73f2aa1","994":"54a88f36"}[chunkId] + ".chunk.css";
};